import {
  HeaderSearch as HeaderSearchComponent,
  HeaderSearchInputWrapper,
  InputSelect,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import decorationImage from '../../assets/decoration.webp';
import * as Styled from './styled';
import type { HeaderSearchProps } from './types';

export const HeaderSearch: FC<HeaderSearchProps> = (props) => {
  const { searchInput } = props;
  const { translate } = useTranslation();

  return (
    <HeaderSearchComponent
      title={translate('breedList.title')}
      childrenWrapperContainerProps={{ style: { maxWidth: 700 } }}
      css={Styled.HeaderStyled}
      bannerChildren={<Styled.HeaderDecorationImage src={decorationImage} />}
      withOverlay
    >
      <HeaderSearchInputWrapper>
        <InputSelect<string>
          placeholder={translate('common.inputs.breedSearch.placeholder')}
          {...searchInput}
        />
      </HeaderSearchInputWrapper>
    </HeaderSearchComponent>
  );
};
